import { render } from "./SpaDayDetails.vue?vue&type=template&id=ec0c5954&scoped=true"
import script from "./SpaDayDetails.vue?vue&type=script&lang=js"
export * from "./SpaDayDetails.vue?vue&type=script&lang=js"

import "@/shared/css/details.css?vue&type=style&index=0&lang=css&external"
import "./SpaDayDetails.vue?vue&type=style&index=1&id=ec0c5954&scoped=true&lang=css"
import "./SpaDayDetails.vue?vue&type=style&index=2&id=ec0c5954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0c5954"]])

export default __exports__